import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from 'src/util/axios-instance';
import {
  CreateDynamicLinkRequestParams,
  CreateDynamicLinkResponseData
} from './interfaces/createDynamicLink.interface';

export const createDynamicLink = async (
  params: CreateDynamicLinkRequestParams
): Promise<CreateDynamicLinkResponseData | undefined> => {
  const { projectId, requestBody } = params;

  const response = await api.post<CreateDynamicLinkResponseData>(
    `${API_URL}/v1/project/${projectId}/dynamicLinks`,
    requestBody,
    { headers: { 'x-session-id': getCachedSessionId() } }
  );

  return response.data;
};
